import { Box, Card, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { TreeDataPlan } from "../data";
import { useTranslate } from "src/locales";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useSnackbar } from "notistack";
import nurseService from "src/api/nurse/nurseService";
import dayjs from "dayjs";
import ByzMuiSaveButton from "src/components/core-components/mui/buttons/ByzMuiSaveButton";

//MPOGLU;443876;19022025
interface PatientCareEditProps {
  selectedRow: TreeDataPlan | null;
  pcsid: number;
  onClose: () => void;
  onSave: (updatedRow: any) => void;
}

function PatientCarePlanEdit({ selectedRow, pcsid, onClose, onSave }: PatientCareEditProps) {
  const [applied, setApplied] = useState(false);
  const [notApplied, setNotApplied] = useState(false);
  const [appliedNote, setAppliedNote] = useState("");
  const [notAppliedNote, setNotAppliedNote] = useState("");
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (selectedRow) {
      const isApplied = String(selectedRow.is_implemented) === "1";
      const isNotApplied = String(selectedRow.is_not_implemented) === "1";
      setApplied(isApplied);
      setNotApplied(isNotApplied);
      if (isApplied) {
        setAppliedNote(selectedRow.note || "");
        setNotAppliedNote("");
      } else if (isNotApplied) {
        setNotAppliedNote(selectedRow.note || "");
        setAppliedNote("");
      } else {
        setAppliedNote("");
        setNotAppliedNote("");
      }
    } else {
      setApplied(false);
      setNotApplied(false);
      setAppliedNote("");
      setNotAppliedNote("");
    }
  }, [selectedRow]);

  const handleAppliedChange = () => {
    if (!applied) {
      setApplied(true);
      setNotApplied(false);
      setNotAppliedNote("");
    } else {
      setApplied(false);
      setAppliedNote("");
    }
  };

  const handleNotAppliedChange = () => {
    if (!notApplied) {
      setNotApplied(true);
      setApplied(false);
      setAppliedNote("");
    } else {
      setNotApplied(false);
      setNotAppliedNote("");
    }
  };

  const getPayloadNote = () => {
    if (applied) return appliedNote;
    if (notApplied) return notAppliedNote;
    return "";
  };

  const handleSave = async () => {
    if (!selectedRow) return;
    setLoading(true);
    const now = new Date().toISOString();
    const finalNote = getPayloadNote().trim();
    const payload = {
      id: selectedRow.id,
      note: finalNote,
      processtime: now,
      isImplement: applied ? "1" : "0",
      isNotImplement: notApplied ? "1" : "0",
    };
    try {
      await nurseService.patientNurseCarePlan.updatePatientNurseCarePlanDetailPeriod(payload);
      enqueueSnackbar(t("messages.update-success"), { variant: "success" });
      if (onSave) {
        onSave({
          ...selectedRow,
          note: finalNote,
          is_implemented: applied ? "1" : "0",
          is_not_implemented: notApplied ? "1" : "0",
          processtime: now,
        });
      }
      setLoading(false);
      if (onClose) onClose();
    } catch (error) {
      enqueueSnackbar(t("messages.update-error"), { variant: "error" });
      console.error(error);
      setLoading(false);
    }
  };

  // Api Geldiğinde Açılacak
  //   const [seans, setSeans] = useState("");
  //   const [reached, setReached] = useState("");
  //   const [notreached, setNotreached] = useState("");
  //   const [processTime, setProcessTime] = useState("");
  //   const [processor, setProcessor] = useState("");
  //   const [note, setNote] = useState("");
  //   useEffect(() => {
  //     const fetchData = async () => {
  //       if (pcsid) {
  //         try {
  //           const data = await PatientCareService.listPlanId(pcsid); // API'den veri çek
  //           if (data) {
  //             setName(data.name);
  //             setStatus1(data.status1 === "Ulaşıldı");
  //             setStatus2(data.status2 === "Ulaşılmadı");
  //           }
  //         } catch (error) {
  //           console.error("Veri çekme hatası:", error);
  //         }
  //       }
  //     };

  //     fetchData();
  //   }, [pcsid]);

  //   const handleSave = async () => {
  //     const data = {
  //     id,
  //     seans,
  //     reached,
  //     notreached,
  //     processTime,
  //     processor,
  //     note,
  //     };

  //     try {
  //       const result = await PatientCareService.create(data, pcsid); // API'ye veri gönder
  //       console.log("Kaydedildi:", result);
  //     } catch (error) {
  //       console.error("Hata:", error);
  //     }
  //   };
  const { t } = useTranslate();
  return (
    <Box>
      <Grid sx={{ margin: "2px", p: 1, borderBottom: "1px solid black" }}>
        <ByzMuiSaveButton
          onClick={handleSave}
          disabled={loading}
          loading={loading}
          popup={false}
        />
      </Grid>

      {/* YATAY;443935;03042025;TALEPTEKI TASARIMA GORE KODDA DEGISIKLIKLER YAPILDI  */}
      <Card sx={{ borderRadius: 0, height: "100%" }}>
        <Grid container spacing={2} alignItems="stretch" sx={{ height: "100%" }}>
          <Grid item xs={7} marginTop={1} sx={{ bgcolor: "#F4F7FE" }} >
            <ByzMuiTypography variant="subtitle1">
              {t("Seans tarihi")}
            </ByzMuiTypography>
          </Grid>
          <Grid item xs={5} display="flex" justifyContent="center" alignItems="center" sx={{ height: "100%" }}>
            <ByzMuiTextField
              label={t("Seans tarihi")}
              variant="outlined"
              fullWidth
              multiline
              rows={2}
              margin="normal"
              disabled={true}
              value={selectedRow?.time ? dayjs(selectedRow.time).format("DD.MM.YYYY HH:mm") : ""}
              onChange={(e) => console.log(e.target.value)}
            />
          </Grid>
        </Grid>
      </Card>

      <Card sx={{ borderRadius: 0, height: "100%" }}>
        <Grid container alignItems="stretch" sx={{ height: "100%" }} spacing={2}>
          <Grid item xs={7} sx={{ bgcolor: "#F4F7FE" }}>
            <ByzMuiTypography variant="subtitle1" marginTop={1}>
              {t("patient-care-guide.applied")}
            </ByzMuiTypography>
          </Grid>
          <Grid item xs={5}>
            <Grid container alignItems="center">
              <ByzMuiCheckBox checked={applied} onChange={handleAppliedChange} />
              {/*Api Geldiğinde Açılacak*/}
              {/* <FormControlLabel
                control={<ByzMuiCheckBox checked={applied} onChange={() => setReached(!applied)} />}
                label="" // Label'ı boş bırakıyoruz
              /> */}
            </Grid>
            <Grid container alignItems="center">
              <ByzMuiTextField
                label={t("patient-care-guide.note")}
                variant="outlined"
                fullWidth
                margin="normal"
                disabled={!applied}
                value={applied ? appliedNote : ""}
                onChange={(e) => setAppliedNote(e.target.value)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Card>

      <Card sx={{ borderRadius: 0, height: "100%" }}>
        <Grid container alignItems="stretch" sx={{ height: "100%" }} spacing={2}>
          <Grid item xs={7} sx={{ bgcolor: "#F4F7FE" }} marginTop={1}>
            <ByzMuiTypography variant="subtitle1">
              {t("patient-care-guide.not-applied")}
            </ByzMuiTypography>
          </Grid>
          <Grid item xs={5}>
            <Grid container alignItems="center">
              <ByzMuiCheckBox checked={notApplied} onChange={handleNotAppliedChange} />
              {/*Api Geldiğinde Açılacak*/}
              {/* <FormControlLabel
                control={<ByzMuiCheckBox checked={notreached} onChange={() => setNotreached(!notApplied)} />}
                label="" // Label'ı boş bırakıyoruz
              /> */}
            </Grid>
            <Grid container alignItems="center">
              <ByzMuiTextField
                label={t("patient-care-guide.note")}
                variant="outlined"
                fullWidth
                margin="normal"
                disabled={!notApplied}
                value={notApplied ? notAppliedNote : ""}
                onChange={(e) => setNotAppliedNote(e.target.value)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Card>

    </Box>
  );
}

export default PatientCarePlanEdit;